import { getMarketsFromMarketGroup } from './getMarketsFromMarketGroup';
import { findSelectionById } from './findSelectionById';
export const getIsSelectionActive = (marketGroup, slipSelection) => {
    const { players, periods, teams } = getMarketsFromMarketGroup(marketGroup);
    const { id, active } = slipSelection;
    let isMarketActive;
    let isSelectionActive;
    players.forEach((player) => {
        periods.forEach((period) => {
            teams.forEach((team) => {
                if (player && team && period && marketGroup.markets[team][period][player]) {
                    const market = marketGroup.markets[team][period][player];
                    const selection = findSelectionById(market, id);
                    if (selection) {
                        ({ active: isMarketActive } = market);
                        ({ active: isSelectionActive } = selection);
                    }
                }
                else if (team && period && marketGroup.markets[team][period]) {
                    const market = marketGroup.markets[team][period];
                    const selection = findSelectionById(market, id);
                    if (selection) {
                        ({ active: isMarketActive } = market);
                        ({ active: isSelectionActive } = selection);
                    }
                }
                else if (team && !period) {
                    const market = marketGroup.markets[team];
                    const selection = findSelectionById(market, id);
                    if (selection) {
                        ({ active: isMarketActive } = market);
                        ({ active: isSelectionActive } = selection);
                    }
                }
                else if (!team && period) {
                    const market = marketGroup.markets[period];
                    const selection = findSelectionById(market, id);
                    if (selection) {
                        ({ active: isMarketActive } = market);
                        ({ active: isSelectionActive } = selection);
                    }
                }
            });
        });
    });
    // Covers corner case when selection in slip is set as active/suspended and update from diffusion don't change selection state
    if (isSelectionActive === undefined && isMarketActive === undefined)
        return active;
    // Selection is active if both market and selection is not considered suspended
    return isSelectionActive !== false && isMarketActive !== false;
};
